import { useQuery } from '@tanstack/react-query';

import { getThreadMessages } from 'entities/chat/api/chatClient';

// Latest page of the caller's most recent thread, refetched on every open so freshly-sent messages
// show up as history. Retries transient server (5xx) errors; the panel degrades to an empty thread
// if it ultimately fails.
export function useLatestThreadPage() {
  return useQuery({
    queryKey: ['chat', 'latest-thread-page'],
    queryFn: () => getThreadMessages(),
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    retry: (failureCount, error) =>
      failureCount < 2 &&
      typeof error === 'object' &&
      error !== null &&
      'status' in error &&
      typeof error.status === 'number' &&
      error.status >= 500,
  });
}
